import React, { FC } from 'react';
import { Badge, Row, Typography } from 'components';
import {
  PURCHASE_ORDER_ITEM_STATUS_MAPPING,
  PURCHASE_ORDER_STATUS_MAPPING,
  PurchaseOrderItemStatusType,
  PurchaseOrderStatusType,
} from 'models/PurchaseOrder';
import styles from './styles.module.scss';

const { Text } = Typography;

interface IItemStatusBadge {
  tooltip?: string;
  type: Exclude<PurchaseOrderItemStatusType, 'ALL'>;
}

interface IStatusBadge {
  tooltip?: string;
  type: PurchaseOrderStatusType;
}

export const PurchaseOrderItemStatusBadge: FC<IItemStatusBadge> = React.memo((props) => {
  const { type } = props;
  const status = PURCHASE_ORDER_ITEM_STATUS_MAPPING[type] || {};
  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
export const PurchaseOrderStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;
  const status = PURCHASE_ORDER_STATUS_MAPPING[type] || {};
  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text ellipsis={{ tooltip: true }} style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>
        {status.label}
      </Text>
    </Row>
  );
});
